// extracted by mini-css-extract-plugin
export default {"denied":"PermissionDenied_denied__KMVn2"};